import { TextField, Button } from "@mui/material";
import DataTable from "react-data-table-component";
import AllServices from "../../Services/AllServices";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CustomLoader from "../CustomLoader/CustomLoader";
import "./dataTable.scss";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewPastGuestDetails from "../ViewPastGuestDetails/ViewPastGuestDetails";

const DataTableCompo = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabledata, setTableData] = useState([]);
  const [disabledIcon, setDisabledIcon] = useState(false);
  const [searchParams, setSearchParams] = useState({
    startDate: "",
    endDate: "",
    gender: "",
    searchText: "",
    page: 1,
    rowsPerPage: 10,
  });
  const [open, setOpen] = useState(false);
  const [totalRecord, setTotalRecords] = useState(0);

  let dataObj = {
    startDate: searchParams.startDate,
    endDate: searchParams.endDate,
    gender: searchParams.gender,
    searchText: searchParams.searchText,
    page: searchParams.page,
    rowsPerPage: searchParams.rowsPerPage,
  };

  const handlePageChange = (page) => {
    setSearchParams((prev) => ({
      ...prev,
      page,
    }));
  };

  const handleRowsPerPageChange = (newRowsPerPage, page) => {
    setSearchParams((prev) => ({
      ...prev,
      rowsPerPage: newRowsPerPage,
      page: 1, // reset to page 1
    }));
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await AllServices.getCustomerDetails(dataObj);
      const data = response.data.data;
      if (Array.isArray(data) && data.length > 0) {
        setTableData(data);
        setDisabledIcon(false);
        setTotalRecords(response.data.pagination.totalRecords);
      } else {
        setDisabledIcon(true);
        setTableData([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClicToExcel = async () => {
    setLoading(true);
    try {
      const blob = await AllServices.getExcelSheet(dataObj);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "customer-details.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Excel downloaded!");
    } catch (error) {
      setLoading(false);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
    }, [500]);

    return () => {
      clearTimeout(handler);
    };
  }, [searchParams]);

  const handleOpen = (row) => {
    const ref_number = row.Booking_Reference_ID;
    setDetails(row);
    setSelectedItem(ref_number);

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    { name: "Reference No", selector: (row) => row.Booking_Reference_ID },
    { name: "First Name", selector: (row) => row.Fname, sortable: true },
    { name: "Last Name", selector: (row) => row.Lname, sortable: true },
    { name: "Mobile No", selector: (row) => row.ContactNumber },
    {
      name: "Arrived Date",
      selector: (row) => row.booking[0]?.Arriving_DateTime.split("T")[0],
      sortable: true,
    },
    {
      name: "Depatured Date",
      selector: (row) => row.booking[0]?.Depature_DateTime.split("T")[0],
      sortable: true,
    },
    { name: "Num Of Adults", selector: (row) => row.booking[0]?.Num_Of_Adults },
    { name: "Num Of Kids", selector: (row) => row.booking[0]?.Num_Of_Kids },

    {
      name: "View",
      cell: (row) => {
        return (
          <button
            className="icon-wrapper visibility"
            onClick={() => handleOpen(row)}
            type="button"
          >
            <VisibilityIcon className="icon" />
            <span>View Details</span>
          </button>
        );
      },
    },

    {
      name: "Status",
      cell: (row) => {
        return (
          <span className="icon-wrapper status-done">
            <Tooltip title="Done">
              <CheckCircleIcon className="icon" />
            </Tooltip>
          </span>
        );
      },
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #f1f5f9",
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "background-color 0.2s ease",
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: "#0f172a",
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "13px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
        fontFamily: "inherit",
        padding: "16px 12px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        justifyContent: "center",
        color: "#334155",
        fontSize: "13.5px",
        fontFamily: "inherit",
      },
    },
  };

  return (
    <div className="data-table-wrapper">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}

      {open && (
        <ViewPastGuestDetails
          refNum={selectedItem}
          onDetails={details}
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
      <div className="filter-containor">
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={searchParams.searchText}
          onChange={(e) =>
            setSearchParams({ ...searchParams, searchText: e.target.value })
          }
          className="field"
        />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            value={searchParams.startDate}
            onChange={(newValue) =>
              setSearchParams({ ...searchParams, startDate: newValue })
            }
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField {...params} size="small" className="field" />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            value={searchParams.endDate}
            onChange={(newValue) =>
              setSearchParams({ ...searchParams, endDate: newValue })
            }
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField {...params} size="small" className="field" />
            )}
          />
        </LocalizationProvider>
        <Button
          variant="contained"
          disabled={disabledIcon}
          onClick={handleClicToExcel}
          startIcon={<GetAppOutlinedIcon />}
          size="small"
          sx={{
            height: "40px",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: "600",
            backgroundColor: "#0f172a",
            color: "#ffffff",
            padding: "8px 16px",
            boxShadow: "0 4px 6px -1px rgba(0, 82, 151, 0.15)",
            "&:hover": {
              // backgroundColor: "#003a66",
              transform: "translateY(-1.5px)",
              boxShadow: "0 6px 10px -1px rgba(0, 82, 151, 0.25)",
            },
            "&:disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              color: "#94a3b8",
            },
            "@media (max-width: 640px)": {
              width: "100%",
            },
          }}
        >
          Export Excel
        </Button>
      </div>

      <div className="table-responsive-wrapper">
        <DataTable
          columns={columns}
          data={tabledata}
          customStyles={customStyles}
          pagination
          paginationServer
          paginationTotalRows={totalRecord}
          paginationPerPage={searchParams.rowsPerPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          className="my-table"
          responsive={true}
        />
      </div>
    </div>
  );
};
export default DataTableCompo;
